// import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Compiler, Component, ElementRef, Injector, NgZone, Optional, PLATFORM_ID, ViewContainerRef, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, ChildrenOutletContexts, Router, RouterModule } from '@angular/router';
import { SwPush, SwUpdate } from '@angular/service-worker';
import { Subscription } from 'rxjs';

import { animate, animateChild, group, query, stagger, state, style, transition, trigger } from '@angular/animations';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalModule, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
// import { FikoYTEnvIstemci } from '@/src/app/Environment/environment';
// import { Overlay } from '@angular/cdk/overlay';

import { FikoYTEnvIstemci } from '../Environment/environment';
import { FikoYTArayuz } from '../fikoyt.arayuz.service';
import { FikoYTService } from '../fikoyt.service';
import { BreakpointObserver } from './breakpoints-observer';
import { Breakpoints } from './breakpoints';
import { LanguageService } from '../language.service';

declare var $: any;

@Component({
  template: ``,
  imports: [RouterModule, FormsModule, ReactiveFormsModule],
  providers: [
    NzModalService,
    // NzMessageService, NzNotificationService,
    // ServisFikoYT
  ],
  changeDetection: ChangeDetectionStrategy.Default,
  animations: [
    trigger('fadeAnimation', [
      transition('* <=> *', [
        // Eski sayfa (leave) animasyonu
        query(':enter, :leave', [
          style({
            position: 'absolute',
            width: '-webkit-fill-available',
            //  opacity: 0,
          }), animateChild(),
        ], { optional: true }),

        group([
          // Eski sayfa (leave) animasyonu
          query(':leave', [
            animateChild(),
            animate('350ms ease-out', style({
              opacity: 0,
            }))
          ], { optional: true }),

          // Yeni sayfa (enter) animasyonu
          query(':enter', animateChild(), { optional: true }),
          query(':enter', [
            style({ opacity: 0 })
            , animateChild(),
            animate('750ms ease-in',
              style({
                opacity: 1,
              }))
          ], { optional: true }),
          query(':leave', animateChild(), { optional: true }),
        ])
      ])
    ]),
    trigger('amazingAnimation1', [
      transition('* <=> *', [
        // Sayfa giriş-çıkış başlangıç stili
        query(':enter, :leave', [
          style({
            position: 'absolute',
            width: '100%',
            height: '100%', // Sabit yükseklik
            overflow: 'hidden',
          })
        ], { optional: true }),

        group([
          // Çıkış yapan sayfa animasyonu (küçülerek ve aşağıya kayarak kaybolacak)
          query(':leave', [
            animate('1500ms ease-out', style({
              transform: 'scale(0.2) translateY(100%)',
              opacity: 0,
            }))
          ], { optional: true }),

          // Yeni gelen sayfa animasyonu (küçük başlayıp büyüyerek yerleşecek)
          query(':enter', [
            style({
              transform: 'scale(0.2) translateY(-100%)',
              opacity: 0,
            }),
            animate('1500ms cubic-bezier(0.2, 1, 0.3, 1)', style({
              transform: 'scale(1) translateY(0)',
              opacity: 1,
            }))
          ], { optional: true }),
        ])
      ])
    ]),

    trigger('amazingAnimation', [
      transition('* <=> *', [
        // Sayfa geçişlerinde başlangıç ayarları
        query(':enter, :leave', [
          style({
            position: 'absolute',
            width: '100%',
          })
        ], { optional: true }),

        group([
          // Eski sayfa animasyonu (Yansıma kayboluyor)
          query(':leave', [
            animate('1500ms ease-out', style({
              transform: 'translateY(100%)',  // Sayfa aşağıya kayacak
              opacity: 0,  // Şeffaflaşacak
            }))
          ], { optional: true }),

          // Yeni sayfa animasyonu (Baloncuk gibi büyüyerek geliyor)
          query(':enter', [
            style({
              opacity: 0,  // Başlangıçta görünmez
              transform: 'scale(0.2) translateY(-100%)',  // Küçük başlayacak ve yukarıdan gelecek
            }),
            animate('1500ms cubic-bezier(0.2, 1, 0.3, 1)', style({
              opacity: 1,  // Görünür olacak
              transform: 'scale(1) translateY(0)',  // Normal boyut ve yerleşim
            }))
          ], { optional: true }),

        ])
      ])
    ]),
    trigger('shatteredAnimation', [
      transition('* <=> *', [
        // Eski sayfanın parçalanarak kaybolması
        query(':enter, :leave', [
          style({
            position: 'absolute',
            width: '100%',
            // opacity: 1,
          }),
          stagger(50, [
            animate('600ms ease-out', style({
              transform: 'translate3d(random(-300px, 300px), random(-300px, 300px), 0)',  // Her parça rastgele kayacak
              opacity: 0,
            }))
          ])
        ], { optional: true }),

        // Yeni sayfanın parçalanarak gelmesi
        query(':enter', [
          style({
            position: 'absolute',
            width: '100%',
            opacity: 0,
          }),
          stagger(-50, [
            animate('800ms cubic-bezier(0.68, -0.55, 0.27, 1.55)', style({
              opacity: 1,
              transform: 'translate3d(0, 0, 0)',  // Başlangıçta parçalar yerinde
            }))
          ])
        ], { optional: true }),
      ])
    ]),
    trigger('rotateTransition', [
      transition('* <=> *', [
        query(':enter, :leave', [
          style({
            position: 'absolute',
            width: '100%',
          }),
        ], { optional: true }),
        query(':enter', [
          style({
            opacity: 0,
          }),
        ], { optional: true }),
        // Eski sayfa dönüşüm ve kaybolma
        query(':enter, :leave', [
          style({
            position: 'absolute',
            width: '100%',
            // opacity: 1,
            transform: 'rotate(0deg)',  // Başlangıçta döndürme yok
          }),
          animate('1000ms ease-out', style({
            opacity: 0,
            transform: 'rotate(180deg) translateY(-100%)',  // Sayfa dönerken yukarı kayacak
          }))
        ], { optional: true }),

        // Yeni sayfa dönüşüm ve giriş
        query(':enter', [
          style({
            position: 'absolute',
            width: '100%',
            opacity: 0,
            transform: 'rotate(-180deg)',  // Başlangıçta ters dönecek
          }),
          animate('1000ms ease-in', style({
            opacity: 1,
            transform: 'rotate(0deg)',  // Yeni sayfa dönüşü tamamlanacak
          }))
        ], { optional: true }),
      ])
    ]),
    trigger('amazingAnimation-1', [
      transition('* <=> *', [
        query(':enter, :leave', [
          style({
            position: 'absolute',
            width: '100%',
          }),
        ], { optional: true }),
        query(':enter', [
          style({
            opacity: 0,
          }),
        ], { optional: true }),
        // Eski sayfa kayboluyor
        query(':leave', [
          style({
            position: 'absolute',
            width: '100%',
            opacity: 1,
            transform: 'scale(1)',  // Başlangıçta normal boyutta
          }),
          animate('800ms ease-out', style({
            opacity: 0,
            transform: 'scale(0) rotate(360deg)',  // Sayfa küçülüp dönerek kayboluyor
            filter: 'brightness(0.5)',  // Parlama etkisi
          }))
        ], { optional: true }),
        // Yeni sayfa kaybolan eski sayfa geçtikten sonra görünüyor
        query(':enter', [
          style({
            position: 'absolute',
            width: '100%',
            opacity: 0,
            transform: 'scale(0.5)',  // Başlangıçta küçük
            filter: 'brightness(1.5)',  // Parlama etkisi
          }),
          animate('800ms ease-in', style({
            opacity: 1,
            transform: 'scale(1)',  // Yeni sayfa büyüyerek görünecek
            filter: 'brightness(1)',  // Parlama efekti kaybolacak
          }))
        ], { optional: true }),
      ])
    ]),
    // Component 
    trigger('fade', [
      transition('* <=> *', [
        group([
          // Eski sayfa (leave) animasyonu
          query(':leave', [
            animate('750ms ease-out', style({
              opacity: 0,
            }))
          ], { optional: true }),

          // Yeni sayfa (enter) animasyonu
          query(':enter', [
            style({ opacity: 0 }),
            animate('750ms ease-in', style({
              opacity: 1,
            }))
          ], { optional: true }),

        ])
      ])
    ]),


    trigger('imageChange', [
      state(
        'hidden',
        style({
          opacity: 0.5,
        })
      ),
      state(
        'visible',
        style({
          opacity: 1,
        })
      ),
      transition('hidden => visible', [animate('500ms ease-in')]),
      transition('visible => hidden', [animate('500ms ease-out')]),
    ]),

  ],
  host: { 'hostID': crypto.randomUUID().toString() }
})
export abstract class FikoYTKokBilesenComponent {
  public $: any;
  /** */
  public readonly env = FikoYTEnvIstemci;
  /** */
  bPnts = Breakpoints;
  /** */
  subsList: Subscription[] = [];
  /** */
  diller: any = {};
  /** Constructor İnjection Servisler */
  public readonly CD: ChangeDetectorRef;
  public readonly FikoYT: FikoYTService;
  public readonly FikoYTArayuz: FikoYTArayuz;
  public readonly contexts: ChildrenOutletContexts;
  public readonly swUpdate: SwUpdate;
  public readonly bPnt: BreakpointObserver;
  public readonly swPush: SwPush;
  // public readonly nzModal: NzModalService;
  public readonly nzNotification: NzNotificationService;
  public readonly nzMessage: NzMessageService;
  @Optional() public readonly nzModalRef: NzModalRef | any;
  public readonly nzModalServis: NzModalService;
  public aktifKullanici: any;
  public readonly route: ActivatedRoute;
  public readonly router: Router;
  public readonly sanitizer: DomSanitizer;
  public readonly elementRef: ElementRef;

  public readonly navigator: any;
  public readonly document: any;

  public readonly compiler: Compiler;
  public readonly ngZone: NgZone;

  public readonly viewContainerRef: ViewContainerRef;
  // public readonly overlay: Overlay;
  public readonly injector: Injector;

  public parametreler: { [key: string]: any } = { "baslik": "FikoYT Yeni Çağ" };
  public globalParametreler: { [key: string]: any };

  public readonly languageService: LanguageService;

  constructor(
    // readonly injector: Injector,
  ) {
    this.CD = inject(ChangeDetectorRef);

    this.FikoYT = inject(FikoYTService);
    this.FikoYTArayuz = inject(FikoYTArayuz);
    this.globalParametreler = []; //this.FikoYT.parametreler;

    this.route = inject(ActivatedRoute);
    this.router = inject(Router);
    this.contexts = inject(ChildrenOutletContexts);
    this.swUpdate = inject(SwUpdate);
    this.swPush = inject(SwPush);
    this.bPnt = inject(BreakpointObserver);

    this.elementRef = inject(ElementRef);


    this.compiler = inject(Compiler);
    this.ngZone = inject(NgZone);

    this.viewContainerRef = inject(ViewContainerRef);
    // this.overlay = inject(Overlay);

    this.injector = inject(Injector);

    this.sanitizer = inject(DomSanitizer);

    if (isPlatformBrowser(inject(PLATFORM_ID))) {
      this.navigator = window.navigator;
      this.document = window.document;
      this.$ = $;
    }

    // this.nzModal = inject(NzModalService);
    this.nzNotification = inject(NzNotificationService);
    this.nzMessage = inject(NzMessageService);
    this.nzModalServis = inject(NzModalService);
    try {
      this.nzModalRef = inject(NzModalRef);
    } catch (error) {
      this.nzModalRef = null;
    }

    this.subsList.push(this.FikoYT.degisti.subscribe(() => {
      this.CD.detectChanges();
    }));


    this.languageService = inject(LanguageService);
  }

  // async ngOnInit() {

  // }

  ngAfterViewInit(): void {
    this.subsList.push(this.bPnt.observe([this.bPnts.XLarge, this.bPnts.Large, this.bPnts.Medium, this.bPnts.Small, this.bPnts.XSmall]).subscribe((val: any) => {
      setTimeout(async () => {
        this.CD.detectChanges();
      }, 0);
    }));

  }

  ngOnDestroy(): void {
    this.subsList?.forEach(element => {
      element?.unsubscribe();
    });
  }

  // dialogTemplate(tplContent: any, tplTitle: any = null,): void {
  //   this.nzModal.create({
  //     nzTitle: tplTitle,
  //     // nzBodyStyle: { "text-align": "center" },
  //     nzContent: tplContent,
  //     nzFooter: null,
  //     nzMaskClosable: true,
  //     nzClosable: false,
  //     // nzOnOk: () => console.log('Click ok')
  //   });
  // }
  // tr(sentences) {
  //   if (this.diller[this.FikoYT.parametreler.language?.code])
  //     return this.diller[this.FikoYT.parametreler.language.code][sentences] ?? sentences
  //   return sentences;
  // }
}

// /** AYRAÇ: */
// @Component({
//     template: ``,
//     imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule],
//     providers: [
//     // ServisFikoYT
//     ],
//     animations: [
//         trigger('fadeAnimation', [
//             transition('* => *', [
//                 query(':enter', [
//                     style({ opacity: 0, })
//                 ], { optional: true }),
//                 group([
//                     query(':leave', [
//                         style({ display: "none" }),
//                     ], { optional: true }),
//                     query(':enter', animateChild(), { optional: true }),
//                     query(':enter', [
//                         animate(750, style({ opacity: 1, })),
//                     ], { optional: true }),
//                     query(':leave', animateChild(), { optional: true }),
//                 ])
//             ])
//         ]),
//     ]
// })
// export class FikoYTKokVeriBilesenComponent extends FikoYTKokBilesenComponent {
//   // veriModulu: any = null;
//   veriSablon: any = null;
//   istekParametreleri: any = null;
//   /** */
//   @ViewChild("FikoFilitreci", { static: false }) fikoFilitreci?: FikoFilitreciComponent;

//   istekSayfalama: IstekSayfalama;

//   aramaGenel: string = "";

//   tabloAyarlar: {
//     sutunlar: {

//       title: any,
//       width?: string,
//       maxWidth?: number,
//       minWidth?: number,
//       align?: string,
//       data?: string,
//       olcuYonu?: "right" | "left",
//     }[]
//   } & any;

//   /** */
//   #listelemeModu: "Liste" | "Kart" = "Kart";
//   public get listelemeModu(): "Liste" | "Kart" {
//     return this.#listelemeModu;
//   }
//   public set listelemeModu(v: "Liste" | "Kart") {
//     this.#listelemeModu = v;
//     this.FikoYT.ayarlar.ekleYadaGuncelleTek(v, (this.istekParametreleri?.komut ?? "FikoYT.kok") + ".listelemeModu").then();
//   }

//   constructor(

//     // readonly injector: Injector,
//   ) {
//     super();

//   }

//   async ngOnInit(): Promise<void> {
//     this.istekSayfalama = new IstekSayfalama(this.istekParametreleri ?? {});

//     this.FikoYT.ayarlar.getByPrimaryKey((this.istekParametreleri?.komut ?? "FikoYT.kok") + ".listelemeModu").then(val => {
//       if (val) {
//         this.#listelemeModu = val;
//       } else {
//         this.#listelemeModu = "Kart";
//       }
//       this.CD.detectChanges();
//     });
//   }

//   ngAfterViewInit(): void {
//     super.ngAfterViewInit();
//     this.listeyiAl();
//   }

//   ngOnDestroy(): void {
//     super.ngOnDestroy();
//   }

//   filitreCevirSql() {
//     if (this.istekSayfalama.suzgecModu() == 1) {
//       let sorgu = this.fikoFilitreci?.toMongo()

//       return sorgu ? { $match: sorgu } : null;
//     } else {

//       if (this.aramaGenel?.trim() == '') {
//         return null
//       }
//       //----> RS+: 
//       let sonuc: any = [
//         { 'hadis': { $regex: this.aramaGenel, $options: 'i' } },
//         { 'kaynak': { $regex: this.aramaGenel, $options: 'i' } },
//       ]

//       try {
//         sonuc.push({ 'sNo': Number.parseInt(this.aramaGenel) });
//       } catch (error) {

//       }

//       return {
//         $match: {
//           $or: sonuc
//         }
//       };
//     }
//   }

//   async listeyiAl() {

//     this.istekSayfalama.filitre = this.filitreCevirSql();
//     await this.istekSayfalama.listeyiAl();

//   }

// }
